import * as React from 'react'

const InfoIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      ref={ref}
      {...props}
    >
      <path
        fill="#71717A"
        d="M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667m.833 12.5H9.167v-5h1.666zm0-6.667H9.167V5.833h1.666z"
      ></path>
    </svg>
  ),
)

InfoIcon.displayName = 'InfoIcon'

export { InfoIcon }
